import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';

const Breadcrumb = ({ breadcrumbs, style }) => {
  return (
    <>
      <style jsx>{`
        .ac-breadcrumb {
          list-style: none;
          padding: 0;
          margin: 0;
          margin-bottom: 20px;
        }

        .ac-breadcrumb li {
          display: inline;
        }

        .ac-breadcrumb a {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }

        .ac-breadcrumb a :hover {
          color: #40a9ff;
        }

        .breadcrumb-separator {
          margin: 0 8px;
          color: rgba(0, 0, 0, 0.45);
        }

        .breadcrumb-name:last-child {
          color: rgba(0, 0, 0, 0.65);
        }
      `}</style>
      <ol style={style} className="ac-breadcrumb">
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((it, idx) => ({
              '@type': 'ListItem',
              position: idx + 1,
              name: it.name,
              item: {
                '@id': it.href,
                name: it.name,
              },
            })),
          }}
        />
        {breadcrumbs.map((bc, idx) => (
          <li key={bc.href}>
            {idx + 1 < breadcrumbs.length ? (
              <Link
                href={bc.href || ''}
                passHref
                prefetch={bc.prefetch !== undefined ? bc.prefetch : false}
              >
                <a>
                  <span className="breadcrumb-name">{bc.name}</span>
                  <span className="breadcrumb-separator">/</span>
                </a>
              </Link>
            ) : (
              <span className="breadcrumb-name">{bc.name}</span>
            )}
          </li>
        ))}
      </ol>
    </>
  );
};

Breadcrumb.propsTypes = {
  breadcrumbs: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    prefetch: PropTypes.bool,
  }),
};

Breadcrumb.defaultProps = {
  breadcrumbs: [],
  style: {},
};

export default Breadcrumb;
